import { useState, useEffect, useRef } from "react";
import router, { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import cx from "classnames";

import { Icon } from "common/ui/Icon";

import { useDebouncedCallback } from "common/middleware/hooks";

import styles from "./SearchBar.module.scss";

interface Props {
  placeholder?: string,
  fullWidth?: boolean,
}

export function SearchBar({ placeholder, fullWidth }: Props) {
  const { query, isReady } = useRouter();
  const { t } = useTranslation("common");

  const [value, setValue] = useState("");

  const input = useRef(null);

  const search = useDebouncedCallback(() => setValue(input.current.value), 250);

  useEffect(() => {
    if (!isReady) return;

    if (!value) {
      delete query.search;
      router.replace({ query: { ...query } }, undefined, { shallow: true });
      return;
    }

    router.replace({ query: {...query, search: value} }, undefined, { shallow: true });
  }, [value, isReady]);

  return (
    <div className={cx(styles.SearchBar, {
      [styles.fullWidth]: fullWidth,
    })}>
      <Icon icon="searchMajor" />
      <input
        ref={input}
        placeholder={placeholder || t("searchBar.search")}
        onChange={search}
      />
      {value && (
        <Icon
          icon="closeMinor"
          onClick={() => {
            setValue("");
            input.current.value = "";
          }}
        />
      )}
    </div>
  )
}
